/**
 * The intent type of a question
 * Shared F/E and API enum
 */
export enum ViIntentEnum {
    informational = 'Informational',
    comparative = 'Comparative',
    transactional = 'Transactional',
    navigational = 'Navigational',
    verification = 'Verification',
}
